import {graneroInstance} from './index.js';

export const createReference = (dataset, collectionId, featureId) => {
  return `pl:features/${dataset}/${collectionId}/${featureId}`;
};

export const referenceToUrl = reference => {
  const parts = reference.split('/');
  // refer to the collection
  let url = `${graneroInstance.defaults.baseURL}/ogc/${parts[1]}/collections/${parts[2]}`;
  if (parts.length > 2 && parts[3]) {
    url += `/items/${parts[3]}`;
  }
  return url;
};

export const parseReference = reference => {
  const parts = reference.split('/');
  let featureId;

  if (parts.length > 2) {
    const featureRef = parts[3].split('#');
    if (featureRef.length > 0) {
      featureId = featureRef[0];
    }
  }

  return {
    dataset: parts[1],
    collectionId: parts[2],
    featureId,
  };
};

export const getLink = (object, rel) => {
  const link = object.links.filter(link => link.rel === rel)[0];
  if (!link) {
    throw Error(
      `missing-${rel}: Malformed object is missing the rel=${rel} link"`
    );
  }
  return link.href;
};

export const getIdFromLink = href => {
  // the ID should be the last bit in the URL
  const elements = href.split('/');
  if (elements[elements.length - 1].length < 1) {
    elements.pop();
  }
  return elements.pop();
};

export const getFeatureReference = feature => {
  if (!feature) {
    return '';
  }

  let shortRef = feature.properties['pl:ref'];

  if (!shortRef) {
    try {
      shortRef = getLink(feature, 'short');
    } catch {
      shortRef = '';
    }
  }
  return shortRef;
};
